import { cva } from "cva";

export const headerContainerStyles = cva("px-6 py-4 sm:py-6 lg:p-8", {
  defaultVariants: {
    appearance: "light",
  },
  variants: {
    appearance: {
      brand: "bg-brand-indigo",
      dark: "bg-gray-900",
      light: "bg-white",
      dark_image: "bg-gray-900",
      light_image: "bg-white",
    },
  },
});
